import Vue from 'vue'
import { repository, fullCollection, datatableCollection } from '@/packages/vue-repository'

const endpoint = 'notes'

export default ({ api }) => {
  return new Vue({
    mixins: [
      repository({ api, endpoint }),
      fullCollection({ api, endpoint }),
      datatableCollection({ api, endpoint })
    ]
  })
}